import { defaultColumns, defaultSort } from '../../components/representativeProcesses/representativeReplacements/columns';

export default {
  state: {
    representativeReplacements: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'desc',
    },
  },
  getters: {
    representativeReplacements: state => state.representativeReplacements,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setRepresentativeReplacements(state, representativeReplacements) {
      state.representativeReplacements = representativeReplacements;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/representative-replacement-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'representative-replacement-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const representativeReplacements = await axios.get('api/representative-replacements' + (query || ''));
        commit('setRepresentativeReplacements', representativeReplacements);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      return await axios.get(`api/representative-replacements/${id}`);
    },

    async create({ commit }, payLoad) {
      await axios.post('api/representative-replacements', payLoad);
    },

    async update({ commit }, payLoad) {
      await axios.put('api/representative-replacements', payLoad);
    },

    async delete({ commit }, id) {
      await axios.delete(`api/representative-replacements/${id}`);
    },
  },
};
